// extracted by mini-css-extract-plugin
export default {"copy":"kga-z","sizingCopy":"lga-z","recommendedFitText":"mga-z"};